/**
 * auto-generated enum by saas-tool
 **/
export enum LOCALE_CATEGORIES {
  AUTH = "auth",
  CHATBOT = "chatbot",
  ERRORS = "errors",
  GENERIC = "generic",
  JOURNEY = "journey",
  LEGAL = "legal",
  LEXICON = "lexicon",
}
